'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiVolumeUp = function TiVolumeUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.8 17.2c-0.6-0.7-1.7-0.7-2.3 0-0.7 0.6-0.7 1.7 0 2.3 0.6 0.6 0.9 1.4 0.9 2.2 0 0.8-0.3 1.5-0.9 2.1-0.7 0.7-0.7 1.7 0 2.4 0.3 0.3 0.7 0.5 1.2 0.5s0.8-0.2 1.1-0.5c1.3-1.2 1.9-2.8 1.9-4.5s-0.6-3.3-1.9-4.5z m3.4-3.4c-0.7-0.6-1.7-0.6-2.4 0-0.6 0.7-0.6 1.7 0 2.4 1.5 1.4 2.3 3.4 2.3 5.5 0 2-0.8 4-2.3 5.5-0.6 0.6-0.6 1.7 0 2.3 0.3 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c2.1-2.1 3.2-4.9 3.2-7.8 0-3-1.1-5.8-3.2-7.9z m3.3-3.3c-0.6-0.7-1.7-0.7-2.3 0-0.7 0.6-0.7 1.7 0 2.3 2.3 2.4 3.6 5.5 3.6 8.9 0 3.3-1.3 6.4-3.6 8.8-0.7 0.6-0.7 1.7 0 2.3 0.3 0.4 0.7 0.5 1.1 0.5s0.9-0.1 1.2-0.5c3-2.9 4.6-6.9 4.6-11.1 0-4.3-1.6-8.2-4.6-11.2z m-14.3-0.8c-0.7 0-1.5 0.3-2.2 0.8l-4.5 2.9c-1.2 0.9-3.7 1.6-5.2 1.6-2.7 0-5 2.2-5 5v3.3c0 2.8 2.3 5 5 5 1.5 0 4 0.8 5.2 1.6l4.5 3c0.7 0.5 1.5 0.7 2.2 0.7 1.5 0 3.1-1.1 3.1-3.6v-16.7c0-2.5-1.6-3.6-3.1-3.6z m-11.9 15.3c-0.9 0-1.6-0.7-1.6-1.7v-3.3c0-0.9 0.7-1.7 1.6-1.7 2.1 0 4.9-0.8 6.7-1.9v10.5c-1.8-1.1-4.6-1.9-6.7-1.9z m11.7 5c0 0.1 0 0.1 0 0.2-0.1 0-0.1-0.1-0.2-0.1l-3.1-2.1v-12.7l3.1-2.1c0.1 0 0.1 0 0.2-0.1 0 0.1 0 0.2 0 0.2v16.7z' })
        )
    );
};

exports.default = TiVolumeUp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/volume-up.js
// module id = 3821
// module chunks = 0